import { render, staticRenderFns } from "./DiscussionDetails.vue?vue&type=template&id=fa85656e&scoped=true&"
import script from "./DiscussionDetails.vue?vue&type=script&lang=js&"
export * from "./DiscussionDetails.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionDetails.vue?vue&type=style&index=0&id=fa85656e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa85656e",
  null
  
)

export default component.exports